import React, { useMemo } from 'react';
import InputText from 'app/components/common/InputText';
import classNames from 'classnames/bind';
import useLayer from 'app/hook/common/useLayer';
import FadeUpModal from 'app/components/common/FadeUpModal';
import BankChooser from 'app/components/common/BankChooser';
import { TOSS_VIRTUAL_ACCOUNT_BANK_LIST } from 'app/constants/bank';
import { numberWithCommas } from 'app/libs/number';
import styles from './CreateAccountForm.module.scss';

const cx = classNames.bind(styles);

function CreateAccountForm({
	amount,
	bank,
	title = undefined,
	isOncePayment = false,
	amountValidationText = '',
	bankValidationText = '',
	onChangeAmount = undefined,
	onChangeBank = undefined,
	onBlurAmount = undefined,
	onCloseBankChooser = undefined,
	style = undefined,
}) {
	const { view, handleLayerOpen, handleLayerClose } = useLayer();

	const onClickBank = (newBank) => {
		handleLayerClose();
		if (newBank) onChangeBank(newBank);
		onCloseBankChooser?.(newBank);
	};

	const amountUnit = useMemo(() => {
		const amountNum = Number(amount);
		if (amountNum < 1000000) return '';

		const uk = Math.floor(amountNum / 100000000);
		const ukRemain = amountNum % 100000000;
		const man = Math.floor(ukRemain / 10000);
		const won = ukRemain % 10000;
		const ukText = uk ? `${numberWithCommas(uk)}억` : '';
		const manText = man ? `${numberWithCommas(man)}만` : '';
		const wonText = numberWithCommas(won) || '';

		return `${[ukText, manText, wonText].filter(Boolean).join(' ')}원`;
	}, [amount]);

	return (
		<>
			<div
				className={cx('account_form')}
				style={style}
			>
				{title && <strong className={cx('account_title')}>{title}</strong>}
				<InputText
					type="customNumber"
					inputMode="numeric"
					name="amount"
					id="amount"
					label="입금 금액"
					labelStyle={{ color: '#666', fontWeight: 'normal' }}
					useLabel
					unitName={amountUnit}
					useUnit
					unitClass={cx('amount_unit')}
					classArray={[cx('input_amount')]}
					placeholder="입금 금액 입력"
					value={amount}
					useCommaFormat
					readOnly={isOncePayment}
					validation={Boolean(amountValidationText)}
					validationText={amountValidationText}
					onChange={(e) => {
						onChangeAmount(e);
					}}
					onBlur={onBlurAmount}
				/>
				<InputText
					style={{ marginTop: 30 }}
					type="text"
					name="bank"
					id="bank"
					label="입금 은행"
					labelStyle={{ color: '#666', fontWeight: 'normal' }}
					useLabel
					placeholder="입금 은행 선택"
					useBtn
					classArray={[cx('input_bank')]}
					btnClass={cx('select_bank')}
					btnName="은행 선택"
					onClick={handleLayerOpen}
					readOnly
					validation={Boolean(bankValidationText)}
					validationText={bankValidationText}
					value={TOSS_VIRTUAL_ACCOUNT_BANK_LIST.find(({ value }) => value === bank)?.label || ''}
				/>
			</div>

			{view && (
				<FadeUpModal
					dimmed
					onClickDimmedArea={() => onClickBank()}
				>
					<strong
						className="dBlock fs22 fcBlack1"
						style={{ marginBottom: 20 }}
					>
						입금할 은행을 선택하세요
					</strong>
					<BankChooser
						bankList={TOSS_VIRTUAL_ACCOUNT_BANK_LIST}
						selectedBank={bank}
						onClick={onClickBank}
					/>
				</FadeUpModal>
			)}
		</>
	);
}

export default CreateAccountForm;
